import { ResponseStatus } from "../enums";
import { DatasetsClient } from "./datasetsClient";

export const datasetsClientStub: DatasetsClient = {
  vote: () => Promise.resolve({ ok: true }),
  getJoinSuggestions: () =>
    Promise.resolve({ status: ResponseStatus.OK, suggestionList: [] }),
  searchDatasets: () =>
    Promise.resolve({ datasetListItems: [], totalDatasetListItems: 0 }),
};
